// extracted by mini-css-extract-plugin
export var dividerContainer = "_6x-0";
export var line = "_6x-1";